// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Column from '../../../components/Column';
import Row from '../../../components/Row';
import Button from '../../../components/Button';

const S = {
  Container: styled(Column)`
    display: flex;
    height: 100%;
  `,
  Button: styled(Button)`
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: #EF8200;
    border-radius: 4px;
    width: 112px;
    box-shadow: revert;
  `,
  BottomWrapper: styled(Row)`
    margin-top: auto;
    margin-bottom: 0px;
    justify-content: flex-end;
  `,
  TopWrapper: styled(Column)`
    margin-bottom: auto;
    position: relative;
  `,
  NotePasswordRule: styled.div`
    font-size: 14px;
    line-height: 20px;
    color: #666666;
    position: absolute;
    top: 66px;
    left: 21px;
  `,
}

export { S as default }
